<main class="checkout-shell checkout-shell--split">
    <div class="app-redirect-overlay" *ngIf="appRedirectCountdown !== null" role="dialog" aria-modal="true" aria-labelledby="app-redirect-title">
        <div class="app-redirect-dialog">
            <p id="app-redirect-title" class="app-redirect-text">
                Redirection vers l'application dans
                <span class="app-redirect-count">{{ appRedirectCountdown }}</span>
                …
            </p>
        </div>
    </div>

    <aside class="checkout-aside" aria-label="Récapitulatif de l'offre">
        <div class="checkout-aside__brand">
            <h2 class="checkout-aside__title">Finaliser votre souscription</h2>
            <p class="checkout-aside__lead" *ngIf="userEmail">
                Connecté en tant que <b>{{ userEmail }}</b>.
            </p>
            <p class="checkout-aside__lead" *ngIf="!userEmail">
                Vérifiez l'offre et le montant avant de payer.
            </p>
            <ul class="checkout-aside__points">
                <li><i class="bx bx-shield-quarter" aria-hidden="true"></i> Paiement mobile money sécurisé</li>
                <li><i class="bx bx-receipt" aria-hidden="true"></i> Montants affichés en MGA</li>
                <li><i class="bx bx-support" aria-hidden="true"></i> Assistance en cas de blocage paiement</li>
            </ul>
        </div>

        <div class="checkout-plan-panel" *ngIf="!planLoading && plan">
            <h2>{{ plan.name }}</h2>
            <p class="checkout-aside-price" *ngIf="checkoutPriceParts(plan) as cp; else asidePricePlain">
                <span>{{ cp.headlineAmountMga | currency : "MGA" : "symbol-narrow" : "1.0-0" : "fr-FR" }}</span>{{ cp.suffix }}
            </p>
            <ng-template #asidePricePlain>
                <p class="checkout-aside-price">{{ checkoutPriceLabel(plan) }}</p>
            </ng-template>
            <p>{{ plan.description }}</p>
        </div>
        <div class="checkout-plan-panel" *ngIf="planLoading">
            <p>Chargement de l'offre…</p>
        </div>
        <div class="checkout-plan-panel" *ngIf="!planLoading && !plan">
            <p>Offre introuvable.</p>
            <a routerLink="/" fragment="pricing" class="checkout-aside__link">Voir les tarifs</a>
        </div>
    </aside>

    <div class="checkout-main">
        <div class="checkout-main__inner">
            <div class="checkout-card">
                <header class="checkout-header">
                    <span class="badge-soft">Paiement</span>
                    <h1>Confirmer et payer</h1>
                    <p>Choisissez votre opérateur mobile money ou démarrez sans paiement si l'offre le permet.</p>
                </header>

                <div class="plan-summary" *ngIf="planLoading">
                    <p class="plan-loading-text">Chargement de l'offre…</p>
                </div>

                <div class="plan-summary" *ngIf="!planLoading && plan" aria-labelledby="plan-summary-title">
                    <h2 id="plan-summary-title" class="plan-summary__mobile-title">{{ plan.name }}</h2>
                    <p class="plan-lead">
                        <ng-container *ngIf="checkoutPriceParts(plan) as cp">
                            <strong class="plan-price-line" [class.plan-price-line--stacked]="!!cp.yearlySubtitle">
                                <span class="plan-price__main">
                                    <span class="plan-price__value">{{
                                        cp.headlineAmountMga | currency : "MGA" : "symbol-narrow" : "1.0-0" : "fr-FR"
                                    }}</span
                                    ><span class="plan-price__suffix">{{ cp.suffix }}</span>
                                </span>
                                <span class="plan-price__tail" *ngIf="cp.yearlySubtitle as sub">
                                    soit
                                    {{ sub.totalYearMga | currency : "MGA" : "symbol-narrow" : "1.0-0" : "fr-FR" }}
                                    /an, payés en une fois. Économie
                                    {{ sub.savingsMga | currency : "MGA" : "symbol-narrow" : "1.0-0" : "fr-FR" }}
                                </span>
                            </strong>
                        </ng-container>
                        <ng-container *ngIf="!checkoutPriceParts(plan)">
                            <strong>{{ checkoutPriceLabel(plan) }}</strong>
                        </ng-container>
                    </p>
                    <p class="plan-subtitle">{{ plan.description }}</p>
                    <ul class="plan-items" *ngIf="plan.items?.length">
                        <li *ngFor="let item of plan.items">
                            <i class="bx bx-check" aria-hidden="true"></i>{{ item }}
                        </li>
                    </ul>
                    <app-ussd-mobile-money-checkout
                        *ngIf="requiresOnlinePayment(plan)"
                        [amountMga]="effectiveCheckoutAmountMga(plan)"
                        [description]="'Souscription - ' + plan.name"
                        [metadata]="{ planId: plan.planId ?? planId }"
                        (paymentConfirmed)="onPaymentConfirmed()"
                    />
                    <div class="plan-no-payment" *ngIf="showFreePlanStartButton(plan)">
                        <p class="plan-no-payment-lead">Aucun paiement requis pour cette formule.</p>
                        <button type="button" class="primary-btn plan-start-btn" (click)="onStartWithoutPayment()">
                            {{ plan.ctaLabel || "Démarrer" }}
                        </button>
                    </div>
                </div>

                <div class="plan-summary plan-summary--unknown" *ngIf="!planLoading && !plan">
                    <p>Cette offre est introuvable ou n'est plus disponible.</p>
                    <a routerLink="/" fragment="pricing" class="muted-link">Voir les tarifs</a>
                </div>

                <div class="checkout-actions">
                    <button type="button" class="secondary-btn" (click)="logout()">Se déconnecter</button>
                </div>
            </div>
        </div>
    </div>
</main>
